<template>
  <Dialog :title="$t('Importar servicios')" v-model="show">
    <!-- Contenido del Dialog -->
    <template v-slot:content>
      <div>
        <div class="container_info_azul">
          <p>{{ $t("Para importar tus servicios, primero descarga la siguiente plantilla de excel y rellena los campos respetando las columnas. Una vez completado el documento sube el archivo.") }}</p>
          <span>{{ $t("Nota: Se recomienda importar los servicios con un código de referencia ya que permitirá que se puedan actualizar de forma masiva mediante otro fichero Excel.") }}</span>
        </div>

        <v-file-input
            v-model="file"
            :label="$t('Seleccionar archivo')"
            accept=".xlsx"
            prepend-icon="mdi-file-excel-outline"
            :clearable="false"
            outlined
        />

        <v-row class="ma-0">
          <a
              :href="`${aws_s3_bucket_url}assets/plantillas/plantilla_importar_servicios.xlsx`"
              style="text-decoration: none"
          >
            <v-btn id="descargar_plantilla" class="primary" dark small>
              <v-icon class="mr-1" small>mdi-file-download</v-icon> {{ $t("Descargar plantilla") }}
            </v-btn>
          </a>
        </v-row>
      </div>
    </template>

    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn :disabled="!file" @click="importar" small class="primary">
        <v-icon class="mr-1" small>mdi-content-save</v-icon>
        {{ $t("Importar") }}
      </v-btn>
    </template>
  </Dialog>
</template>

<script>

export default {
  name: 'ImportarProductos',
  data: () => ({
    file: null,
    aws_s3_bucket_url: process.env.VUE_APP_AWS_S3_BUCKET,
  }),
  props: ['value'],
  methods: {

    /**
     * Importa los servicios
     * @returns {Promise<void>}
     */
    async importar() {
      try {
        await this.$store.dispatch("servicio/importar", this.file)

	      this.$snotify.success(
		      this.$t("Acción realizada con éxito"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
        this.show = false
        this.$emit('on_importar')
      } catch (err) {
        console.log(err)
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
}
</script>
